<template>
  <div class="w-100 text-center">
    <button class="btn btn-primary center" v-on:click="show_more_less(type_of_chart)">
      {{ toggle_btn_class(type_of_chart)['text'] }}
      <i v-bind:class="toggle_btn_class(type_of_chart)['icon']"></i>
    </button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        toggleShowAll: {
          services: 0,
          occupations: 0,
          entities: 0
        }
      }
    },
    props: ['type_of_chart'],
    methods: {
      show_more_less: function (typeOfChart) {
        this.toggleShowAll[typeOfChart] = this.toggleShowAll[typeOfChart] === 0 ? 1 : 0;
        this.$emit(`change_toggle_${typeOfChart}`, typeOfChart, this.toggleShowAll);
      },
      toggle_btn_class: function (typeOfChart) {
        if (this.toggleShowAll[typeOfChart] === 1) {
          return {
            'text': this.$i18n.t('Statistic.BtnShowMoreLess.see_less'),
            'icon': 'fa fa-chevron-up'
          }
        } else {
          return {
            'text': this.$i18n.t('Statistic.BtnShowMoreLess.see_more'),
            'icon': 'fa fa-chevron-down'
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/stats/shared/BtnShowMoreLess.vue